import React, { memo } from "react";
import { Container } from "../styled";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
import { TitleText, TextWrapper } from "./style";
import { IIrctcNonPnrHalfcardData } from "@swiggy-private/cart-types";

interface IEnterPnrProps {
    onEnterPnrCtaClick: () => void;
    nonPnrHalfcardData: IIrctcNonPnrHalfcardData;
}

export const EnterPnr = ({ onEnterPnrCtaClick, nonPnrHalfcardData }: IEnterPnrProps) => {
    return (
        <Container isIrctcFlow={true} data-testid="enter-pnr-container">
            <TextWrapper>
                <TitleText variant="V2.subheading1.neutral.bold" color="text_High_Emphasis">
                    {nonPnrHalfcardData.title}
                </TitleText>
                <Text variant="V2.body2.neutral.medium" color="text_Med_Emphasis">
                    {nonPnrHalfcardData.sub_title}
                </Text>
            </TextWrapper>
            <SuperButton
                variant="fullwidth"
                buttonType="primary"
                buttonSize="large"
                onClick={onEnterPnrCtaClick}
                data-testid="enter-pnr-cta"
            >
                {nonPnrHalfcardData.cta}
            </SuperButton>
        </Container>
    );
};

export default memo(EnterPnr);
